export const firstCapital = (label: string) => {
  if (label)
    return (label?.charAt(0).toUpperCase() + label?.slice(1, label?.length).toLowerCase()).replace(/[^0-9a-z]/gi, ' ');
  else return label;
};
